import dayjs from 'dayjs';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteEventAction, updateEventAction } from '../../../redux/actions/eventsActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';
import EventForm from '../forms/EventForm';

const UpdateEventModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const event = useSelector((state) => state.events?.event);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    await dispatch(
      updateEventAction(event.id, {
        title: data.title,
        startDate: dayjs(data.startDate).toISOString(),
        endDate: dayjs(data.endDate).toISOString(),
      }),
    );
    setLoading(false);
    onModalSubmit();
  };

  const onDelete = async () => {
    setLoading(true);
    await dispatch(deleteEventAction(event.id));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Змінити подію'}
      loading={loading}
      onClose={onModalClose}
      body={
        <EventForm
          onSubmit={onSubmit}
          initEvent={{
            id: event.id,
            title: event.title,
            startDate: event.start,
            endDate: event.end,
          }}
          loading={loading}
        />
      }
      actionButton={
        <div className="flex gap-4">
          <Button
            disabled={loading}
            variant={'secondary'}
            onClick={() => onDelete()}
            formId={'event-form'}
            children={'Видалити'}
          />
          <Button type={'submit'} disabled={loading} variant={'primary'} formId={'event-form'} children={'Зберегти'} />
        </div>
      }
    />
  );
};

export default UpdateEventModal;
